'use strict';

/**
 * Reduced-motion helpers.
 *
 * The CSS side is handled in css/minimal-mistakes/_animations.scss, which
 * deliberately flattens the one entrance keyframe rather than killing every
 * animation — hover, focus and state transitions are feedback and must survive.
 * JS-driven scrolling bypassed that entirely, so it reads the same media query
 * here.
 *
 * Queried per call rather than cached: a visitor can toggle the OS setting
 * without reloading the page.
 */
export const prefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Value for scrollIntoView()'s `behavior`, honouring the user's preference. */
export const scrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth');
